export const UPDATE_TYPES = ['note', 'food', 'toilet', 'activity', 'medicine', 'sleep', 'checkin', 'checkout'] as const
export type UpdateType = typeof UPDATE_TYPES[number]

// Types that can be manually created by users
export const MANUAL_UPDATE_TYPES = ['note', 'food', 'toilet', 'activity', 'medicine', 'sleep'] as const
export type ManualUpdateType = typeof MANUAL_UPDATE_TYPES[number]

export const UPDATE_TYPE_LABELS: Record<UpdateType, string> = {
  note: 'General Note',
  food: 'Food Update',
  toilet: 'Toilet Update',
  activity: 'Activity',
  medicine: 'Medicine',
  sleep: 'Sleep',
  checkin: 'Arrived',
  checkout: 'Left',
}

export const UPDATE_TYPE_ICONS: Record<UpdateType, string> = {
  note: '📝',
  food: '🍽️',
  toilet: '🚽',
  activity: '🎨',
  medicine: '💊',
  sleep: '😴',
  checkin: '👋',
  checkout: '🏠',
}

export interface UpdateChild {
  id: string
  firstName: string
  lastName: string
}

export interface UpdateImage {
  id: string
  thumbnailUrl: string
  fullUrl: string
  width: number
  height: number
  status: string
}

export interface Update {
  id: string
  childminderId: string
  type: UpdateType
  content: string
  createdAt: string
  children: UpdateChild[]
  images?: UpdateImage[]
}

export interface CreateUpdateData {
  type: UpdateType
  content: string
  childIds: string[]
  imageIds?: string[]
}
